// extracted by mini-css-extract-plugin
export default {"Container":"estilo_Container__Qnztt","ContainerGrid":"estilo_ContainerGrid__dQrnk"};